import { useTranslation } from "react-i18next"
import { defaultLanguage } from "./config"
import { getCookie } from "@filmustage/shared"

/**
 * Returns a function that prefixes paths with the user's chosen language.
 * Uses cookie as source of truth (shared with frontend app).
 * EN paths have no prefix (default language).
 */
export function useLangPath() {
  const { i18n } = useTranslation()

  const storedLang =
    typeof window !== "undefined"
      ? getCookie("i18nextLng")
      : null
  const lang = storedLang || i18n.language

  return function langPath(path) {
    if (!lang || lang === defaultLanguage) return path
    // Blog is EN-only, never add lang prefix
    if (path.startsWith("/blog")) return path
    return `/${lang}${path}`
  }
}
